import { RoutesService, eLayoutType } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];

function configureRoutes() {
  const routes = inject(RoutesService);

  // Önce mevcut route'ları ekle
  routes.add([
      {
        path: '/',
        name: 'Menu:Home',
        iconClass: 'fas fa-home',
        order: 1,
        layout: eLayoutType.empty,
      },
      {
        path: '/dashboard',
        name: '::Menu:Dashboard',
        iconClass: 'fas fa-tachometer-alt',
        order: 2,
        layout: eLayoutType.application,
        requiredPolicy: 'AbpIdentity.Users', // Sadece admin kullanıcılar görebilir
      },
      {
        path: '/identity/users',
        name: '::Menu:Users',
        iconClass: 'fas fa-users',
        order: 3,
        layout: eLayoutType.application,
        requiredPolicy: 'AbpIdentity.Users',
      },
      {
        path: '/identity/roles',
        name: '::Menu:Roles',
        iconClass: 'fas fa-id-card',
        order: 4,
        layout: eLayoutType.application,
        requiredPolicy: 'AbpIdentity.Roles',
      },
      {
        path: '/coach/my-students',
        name: '::Menu:MyStudents',
        iconClass: 'fas fa-user-graduate',
        order: 4,
        layout: eLayoutType.application,
        requiredPolicy: 'Io.Coaches.ManageOwnStudents',
      },
      {
        path: '/coach/profile-completion',
        name: '::Menu:ProfileCompletion',
        iconClass: 'fas fa-user-edit',
        order: 4.5,
        layout: eLayoutType.application,
        requiredPolicy: 'Io.Coaches.ManageOwnStudents',
        invisible: true, // Make it invisible in menu by default
      },
      {
        path: '/admin/schools',
        name: '::Menu:SchoolManagement',
        iconClass: 'fas fa-school',
        order: 6,
        layout: eLayoutType.application,
        requiredPolicy: 'AbpIdentity.Users',
      },
      {
        path: '/admin/cities',
        name: '::Menu:CityManagement',
        iconClass: 'fas fa-city',
        order: 7,
        layout: eLayoutType.application,
        requiredPolicy: 'AbpIdentity.Users',
      },
      {
        path: '/admin/districts',
        name: '::Menu:DistrictManagement',
        iconClass: 'fas fa-map-marked-alt',
        order: 8,
        layout: eLayoutType.application,
        requiredPolicy: 'AbpIdentity.Users',
      },
      {
        path: '/coach/dashboard',
        name: '::Menu:CoachDashboard',
        iconClass: 'fas fa-chart-line',
        order: 3,
        layout: eLayoutType.application,
        requiredPolicy: 'Io.FormResponses.ViewStudentResponses',
      },
      {
        path: '/coach/forms',
        name: '::Menu:Forms',
        iconClass: 'fas fa-file-alt',
        order: 5,
        layout: eLayoutType.application,
        requiredPolicy: 'Io.Coaches.ManageOwnStudents',
      },
      {
        path: '/coach/reports',
        name: '::Menu:CoachReports',
        iconClass: 'fas fa-chart-bar',
        order: 5.5,
        layout: eLayoutType.application,
        requiredPolicy: 'Io.Coaches.ManageOwnStudents',
      },
      {
        path: '/coach/student-groups',
        name: '::Menu:StudentGroups',
        iconClass: 'fas fa-users-cog',
        order: 4.5,
        layout: eLayoutType.application,
        requiredPolicy: 'Io.StudentGroups',
      },
      {
        path: '/student/my-assignments',
        name: '::Menu:MyAssignments',
        iconClass: 'fas fa-tasks',
        order: 10,
        layout: eLayoutType.application,
        requiredPolicy: 'Io.StudentMenu.ViewMyAssignments',
      },
      {
        path: '/admin/impersonation',
        name: '::Menu:Impersonation',
        iconClass: 'fas fa-user-secret',
        order: 100,
        layout: eLayoutType.application,
        requiredPolicy: 'Io.Users.ImpersonateUser',
      },
  ]);
}
